import { getSelectors } from '@repo/core'
import { selectorsConfig } from './selectors.const'

export const externalToolLinkDataSelector = getSelectors({
  getRootPath: selectorsConfig.externalToolLinkDataSelector.getRootPath,
})

export const fundScreenerSessionDataSelector = getSelectors({
  getRootPath: selectorsConfig.fundScreenerSessionDataSelector.getRootPath,
})
